
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/distance-sales-agreement",
      function () {
        return require("private-next-pages/distance-sales-agreement/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/distance-sales-agreement"])
      });
    }
  